import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import Fail from "../components/Fail";
import Footer from "../components/Footer";

const PaymentFail = () => {
  return (
    <HelmetProvider>
      <LayoutProvider>
        <TopNavBar
          position="fixed"
          menuItems={[
            ["მთავარი", "home", "/"],
            ["სერვისები", "services", "/services"],
            ["სიახლეები", "news", "/news"],
            ["კონტაქტი", "contact", "/contact"],
            ["ხშირად დასმული კითხვები", "faqs", "/faq"],
            ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
          ]}
        />
        <Fail />
        <Footer />
      </LayoutProvider>
    </HelmetProvider>
  );
};

export default PaymentFail;
